<template>
  <van-popup
    :value="value"
    class="pop"
    position="bottom"
    closeable
    close-icon-position="top-left"
    @input="$emit('input',$event)"
  >
    <div class="box">
      <div class="title">
        {{ title }}
      </div>
      <div class="msg">
        <slot>{{ msg }}</slot>
      </div>
      <div
        class="btn"
        @click="onClickBtn"
      >
        {{ btnText }}
      </div>
    </div>
  </van-popup>
</template>

<script>
import Popup from 'vant/lib/popup/index';

export default {
  name: 'TipModal',
  components: {
    [Popup.name]: Popup,
  },
  props: {
    value: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '我知道了',
    },
    msg: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClickBtn() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.pop {
  border-radius: 30px 30px 0 0;
  /deep/ .van-popup__close-icon{
    color: rgba(0,0,0,0.87);
  }
}
.box {
  padding: 0 36px;
  color: rgba(0,0,0,0.87);
  text-align: center;
  font-size: 32px;
}
.title {
  height: 96px;
  line-height: 96px;
  padding: 0 32px;
}
.msg {
  line-height: 48px;
  padding: 42px 0;
  font-size: 34px;
}
.btn {
  margin: 36px 0;
  height: 90px;
  line-height: 90px;
  font-size: 30px;
  border-radius: 90px;
  background: #1a1a1a;
  color: #fff;
}
</style>
